<template>
  <form @submit.prevent="submit(item)">
    <b-row>
      <b-col cols="12">
        <div class="form-group">
          <label
                  for="excmrelation_title"
                  class="form-control-label">{{$t('views.excmrelation.form.title')}}:</label>
          <input
                  id="excmrelation_title"
                  v-model="item.title"
                  :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('title', $event.target.value)">
          <div
                  v-if="isInvalid('title')"
                  class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col cols="12" v-if="categoryOptions.length > 0">
        <b-form-group>
          <label
                  for="excmrelation_idCategory"
                  class="form-control-label">{{$t('views.exsbitems.list.category')}}:</label>
          <model-select :options="categoryOptions" v-model="item.idCategory"></model-select>
          <div
                  v-if="isInvalid('idCategory')"
                  class="invalid-feedback">{{ violations.idCategory }}</div>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <label
            for="excmnote_idCase"
            class="form-control-label">{{$t('views.excmnote.form.idCase')}}
          </label>
          <BaseSelectInput
            ref="caseInput"
            v-model="item.idCase"
            :search-callback="caseSearchCallback"
            :display-values="['title', 'contractorUserData.fullName', 'contractorUserData.firmname1']"
            :query-param="'contractor'"
            :disabled="isCaseInputDisabled"
            :placeholder-autocomplete="'Zacznij wpisywać kontrahenta'"
            :is-auto-complete-mode="isAutocompleteEnabledForCaseInput"
          ></BaseSelectInput>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <label
            for="excmnote_idCase"
            class="form-control-label">{{$t('views.excmnote.form.idOrganizationLead')}}
          </label>
          <BaseSelectInput
            ref="caseInput"
            v-model="item.idOrganizationLead"
            :search-callback="organizationLeadSearchCallback"
            :display-values="['title']"
            :query-param="'title'"
            :disabled="isOrganizationLeadInputDisabled"
            :placeholder-autocomplete="'Zacznij wpisywać tytuł projektu sprzedażowego'"
            :is-auto-complete-mode="isAutocompleteEnabledForCaseInput"
          ></BaseSelectInput>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-if="!(idFirm && idCase)">
        <b-form-group>
          <b-form-checkbox v-model="isContractorRelation">
            <span v-if="item.contactType === 1">{{ $t('views.excmrelation.form.contractorMeeting') }}</span>
            <span v-else-if="item.contactType === 2">{{ $t('views.excmrelation.form.contractorCall') }}</span>
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-show="isContractorRelation">
        <div class="form-group">
          <label
                  for="excmrelation_userData"
                  class="form-control-label">{{$t('views.excmrelation.form.userData')}}:</label>
          <base-select-input
            v-model="item.userData"
            :search-callback="contractorSearchCallback"
            :display-values="['fullName', 'firmname1']"
            :disabled="isUserDataInputDisabled"
            :query-param="'userdata'"
            :is-auto-complete-mode="isAutocompleteEnabledForUserDataInput"
          ></base-select-input>
          <div
                  v-if="isInvalid('userData')"
                  class="invalid-feedback">{{ violations.userData }}</div>
        </div>
      </b-col>
      <b-col cols="12">
        <div class="form-group">
          <label
            for="excmrelation_description"
            class="form-control-label">{{$t('views.excmrelation.form.description')}}:</label>
          <input
            id="excmrelation_description"
            v-model="item.description"
            :class="['form-control', isInvalid('description') ? 'select-danger' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('description', $event.target.value)">
          <div
            v-if="isInvalid('description')"
            class="invalid-feedback">{{ violations.description }}</div>
        </div>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <label for="date" class="form-control-label">{{$t('views.excmrelation.form.date')}}:</label>
          <el-date-picker
            :picker-options="{firstDayOfWeek: 1}"
            id="date"
            :disabled="dateTimeDisabled"
            v-model="pickedDate"
            type="date"
            format="yyyy-MM-dd">
          </el-date-picker>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <label for="date_from" class="form-control-label">{{$t('views.excmrelation.form.hourFrom')}}:</label>
          <el-time-select
            id="date_from"
            :disabled="dateTimeDisabled"
            v-model="timeFrom"
            :picker-options="{
              start: '06:00',
              step: '00:05',
              end: '22:00'
            }">
          </el-time-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <label for="date_to" class="form-control-label">{{$t('views.excmrelation.form.hourTo')}}:</label>
          <el-time-select
            id="date_to"
            :disabled="dateTimeDisabled"
            v-model="timeTo"
            :picker-options="{
              start: '06:00',
              step: '00:05',
              end: '22:00'
            }">
          </el-time-select>
        </b-form-group>
      </b-col>
        <b-col class="mt-2" v-for="(relationUserData, relationUserDataIndex) in item.relationUserData" v-bind:key="'relationUserData-' + relationUserDataIndex" cols="12">
          <b-row align-v="center">
            <b-col cols="1" class="ml-0 mr-0 pl-0 pr-0 d-flex justify-content-center">
              <span class="h6">#{{ relationUserDataIndex + 1 }}</span>
            </b-col>
            <b-col cols="10">
              <div class="form-group">
                <base-select-input
                  v-model="item.relationUserData[relationUserDataIndex].userData"
                  :search-callback="userDataSearchCallback"
                  :display-values="['fullName', 'firmname1']"
                  :query-param="'userdata'"
                  :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
                ></base-select-input>
              </div>
            </b-col>
            <b-col cols="1">
              <b-btn class="btn btn-link mt-1 mb-3 float-right fa fa-trash-alt fa-lg" @click="removeRelationUserData(relationUserDataIndex)">
              </b-btn>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col>
              <b-btn class="btn btn-sm" @click="addRelationUserData()"><i class="mr-1 fa fa-plus"></i>{{$t('views.excmrelation.form.addRelationUserData')}}</b-btn>
            </b-col>
          </b-row>
        </b-col>
<!--      </template>-->
      <b-col cols="12" lg="12">
        <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUserRoles } from '@/utils/checkRoles.js'
import remove from '@/utils/remove'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import { ModelSelect } from 'vue-search-select'

export default {
  components: { BaseSelectInput, ModelSelect },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },
    idFirm: {
      type: String,
      required: false
    },
    idCase: {
      type: String,
      required: false
    },
    idOrganizationLead: {
      type: String,
      required: false
    },
    initialDateTime: {
      type: String,
      required: false
    },
    initialDuration: {
      type: Number,
      required: false
    }
  },

  data () {
    return {
      isContractorRelation: false,
      timeFrom: '12:00',
      timeTo: '12:15',
      isVisibleDateTo: false,
      userDataSearchParams: {
        pagination: false
      },
      isIdUserDataDisabled: false,
      dateTimeDisabled: false,
      pickedDate: this.$moment().format('YYYY-MM-DD'),
      companyOptions: [],
      categoryOptions: []
    }
  },

  watch: {
    timeFrom () {
      if (this.initialValues || this.initialDateTime) return
      this.timeTo = this.$moment(this.dateFrom).add(15, 'minutes').format('HH:mm')
    },
    isContractorRelation (val) {
      if (val && this.item.idOrganizationLead && !this.idFirm) {
        this.organizationLeadSelectedHandler()
      } else if (!val) {
        this.item.userData = null
        this.item.idCase = null
      }
    },
    'item.userData' (val) {
      if (!this.isAutocompleteEnabledForCaseInput && val) {
        this.$refs.caseInput.initialValueHandler()
      }
    },
    'item.idCase' (val) {
      if (val && !this.idFirm) {
        this.caseSelectedHandler()
      }
    },
    'item.idOrganizationLead' (val) {
      if (val && !this.idFirm) {
        this.organizationLeadSelectedHandler()
      }
    }
  },

  computed: {
    isAutocompleteEnabledForCaseInput () {
      return (this.$store.getters['configuration/enableAutoCompleteForUserData'] && !this.isUserDataInputDisabled) && !this.isContractorRelation
    },
    isAutocompleteEnabledForUserDataInput () {
      return this.$store.getters['configuration/enableAutoCompleteForUserData'] && !this.isCaseInputDisabled
    },
    isCaseInputDisabled () {
      return !!this.idCase
    },
    isUserDataInputDisabled () {
      return !!this.idFirm
    },
    isOrganizationLeadInputDisabled () {
      return !!this.idOrganizationLead
    },
    isUpdate () {
      return this.$route.name === 'EXCMRelationUpdate'
    },
    dateFrom () {
      return this.$moment(this.date + ' ' + this.timeFrom).format('YYYY-MM-DD HH:mm')
    },
    dateTo () {
      return this.$moment(this.date + ' ' + this.timeTo).format('YYYY-MM-DD HH:mm')
    },
    date () {
      return this.$moment(this.pickedDate).format('YYYY-MM-DD')
    },
    ...mapGetters({
      casesOptions: 'lists/list/casesItems',
      userDataOptions: 'lists/list/userDataItems'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    mobileView () {
      return this.$store.state.mobileView
    },

    violations () {
      return this.errors || {}
    }
  },

  mounted () {
    if (this.idFirm && !this.idCase) {
      this.isContractorRelation = true
    }
  },

  created () {
    this.fetchCategories()
    this.handleUpdateDate()
    this.addDefaultRelationUserData()
    if (this.idFirm) {
      this.isIdUserDataDisabled = true
      this.item.userData = this.idFirm
    }
    if (this.idCase) {
      this.item.idCase = this.idCase
    }
    if (this.idOrganizationLead) {
      this.item.idOrganizationLead = this.idOrganizationLead
    }
    if (this.initialDateTime) {
      let initialDateTime = this.$moment(this.initialDateTime)
      this.dateTimeDisabled = true
      this.dateFrom = initialDateTime.format('YYYY-MM-DD')
      this.timeFrom = initialDateTime.format('HH:mm')
      if (this.initialDuration) {
        this.timeTo = initialDateTime.add(this.initialDuration, 'seconds').format('HH:mm')
      } else {
        this.timeTo = initialDateTime.add(15, 'minutes').format('HH:mm')
      }
    }
  },

  methods: {
    async caseSelectedHandler () {
      const response = await new ApiService(this.item.idCase).getResults()
      this.item.userData = response.contractorUserData['@id']
    },
    async organizationLeadSelectedHandler () {
      const response = await new ApiService(this.item.idOrganizationLead).getResults()
      if (response.idUserData) {
        this.item.userData = response.idUserData['@id']
      }
    },
    async caseSearchCallback (params = {}) {
      let baseParams = { pagination: false, contractorUserData: this.idFirm ? getId(this.idFirm) : getId(this.item.userData) }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_cases', baseParams).getResults()
      return response.items
    },
    async contractorSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async organizationLeadSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_organization_leads', baseParams).getResults()
      return response.items
    },
    submit () {
      this.item.dateFrom = this.dateFrom
      this.item.dateTo = this.dateTo
      this.handleSubmit(this.item)
    },
    handleUpdateDate () {
      if (!this.initialValues) return
      this.timeFrom = this.$moment(this.item.dateFrom).format('HH:mm')
      this.timeTo = this.$moment(this.item.dateTo).format('HH:mm')
      this.pickedDate = this.$moment(this.item.dateTo).format('YYYY-MM-DD')
    },
    removeRelationUserData (index) {
      if (this.item.relationUserData[index]['@id']) {
        remove(this.item.relationUserData[index]['@id'], () => {
          this.item.relationUserData.splice(index, 1)
        })
      } else {
        this.item.relationUserData.splice(index, 1)
      }
    },
    addDefaultRelationUserData () {
      if (this.$route.name === 'EXCMRelationUpdate') return
      let path = new URL(this.$http.defaults.baseURL).pathname
      let item = {
        userData: path + 'api/user_datas/' + getUserRoles().id_userdata
      }
      this.item.relationUserData.push(item)
    },
    addRelationUserData () {
      let item = {
        userData: null,
        relation: this.isUpdate ? this.item['@id'] : undefined
      }
      this.item.relationUserData.push(item)
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async fetchCategories () {
      let params = { pagination: false }
      this.categoryOptions = []
      const response = await new ApiService('e_x_c_m_relation_categories', params).getResults()
      this.categoryOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
      if (!this.item['@id'] && this.categoryOptions.length > 0) {
        this.item.idCategory = this.categoryOptions[0].value
      }
    }
  }
}
</script>
<style scoped>
</style>
